export default __webpack_public_path__ + "static/media/plain-sticker-a.0c508c4c.png";